import 'swiper/swiper-bundle.css'
import Swiper, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, EffectFade, Autoplay]);

const config = {
  tile: {
    slidesPerView: 1,
    centeredSlides: false,
    loop: true,
    // allowSlidePrev: false,
    // allowSlideNext: false,
    effect: 'fade',
    speed: 1000,
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 3000
    },
  },
  mini: {
    slidesPerView: 1,
    centeredSlides: false,
    loop: true,
    // allowSlidePrev: false,
    // allowSlideNext: false,
    effect: 'fade',
    speed: 1000,
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 3000
    },
  },
  'tile-mobile': {
    slidesPerView: 1,
    centeredSlides: false,
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 3000
    },
    spaceBetween: (window.innerWidth / 3),
    breakpoints: {
      767: {
        spaceBetween: 15,
      }
    }
  },
  'tile-tablet': {
    slidesPerView: 1,
    centeredSlides: false,
    spaceBetween: (window.innerWidth / 3),
    spaceBetween: 15,
  },
  logo: {
    slidesPerView: 4,
    spaceBetween: 55,
    loop: true,
    navigation: {
      nextEl: '.js-logo-next',
      prevEl: '.js-logo-prev',
    },
    breakpoints: {
      // when window width is >= 320px
      767: {
        slidesPerView: 4,
        spaceBetween: 37,
      },
      // when window width is >= 1024
      1200: {
        slidesPerView: 4,
        spaceBetween: 55,
      }
    }
  },
  testimonial: {
    slidesPerView: 2,
    // spaceBetween: 40,
    slidesPerGroup: 2,
    loop: true,
    navigation: {
      nextEl: '.js-logo-next',
      prevEl: '.js-logo-prev',
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
      // when window width is >= 1024
      1024: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      }
    }
  },
  award: {
    slidesPerView: 3,
    spaceBetween: 58,
    slidesPerGroup: 1,
    loop: true,
    navigation: {
      nextEl: '.js-award-next',
      prevEl: '.js-award-prev',
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
      },
      // when window width is >= 1024px
      1024: {
        slidesPerView: 2,
        slidesPerGroup: 1,
        spaceBetween: 58,
      },
      // when window width is >= 1200px
      1200: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 58,
      }
    }
  }
}

export default class {
  constructor($el) {
    this.$el = $el;
    this.type = $el.data('slider-type');
  }
  initialise() {
    let sliderConfig = config[this.type];
    if (!sliderConfig) {
      return;
    }
    if (this.type === 'tile' || this.type === 'tile-mobile' || this.type === 'mini' || this.type == 'tile-tablet' || this.type === 'award') {
      sliderConfig = {
        ...sliderConfig,
        pagination: {
          el: this.$el.find('.swiper-pagination').get(0),
          clickable: true,
        },
      }
    }
    new Swiper(this.$el.get(0), sliderConfig);
  }
}
